export default "__VITE_ASSET__DsuyP06j__"